import React, { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import { Card, CardBody, Col, Container, Row, Alert } from "reactstrap"
import { useSearchParams } from "react-router-dom";
import axios from "axios";
// import images
import logodark from "../../../assets/images/darklogo.png"
import logolight from "../../../assets/images/whitelogo.png"


const PaymentSuccess = () => {


  const [alertMsgg, setAlertMsgg] = useState<any>({ open: false, type: "success", content: 'Messages here.', time: '2500' });
  const handleAlertMsggClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") { return; }
    setAlertMsgg({ ...alertMsgg, open: false })
  };
  const [showloader, setshowloader] = useState(true);  // State for tracking submission
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id")?.split('?type=')[0];
  const itype = searchParams.get("session_id")?.split('?type=')[1];
  const [error, setError] = useState('');

  const [headTitle, setHeadTitle] = useState((itype == 'platform') ? 'Your subscription is now active.' : 'Your booking is successfull.');
  const [subTitle, setSubTitle] = useState((itype == 'platform') ? 'You can now explore the portal, and start connecting with experts. Find the right expert for your needs and make the most of your subscription!' : 'Your booking is confirmed! You can contact your expert directly. We have sent you an email with their details.');

  useEffect(() => {
    if (!sessionId) {
      // setAlertMsgg({ ...alertMsgg, open: true, content:"Invalid URL!", type:"error" })
      setError("❌ No session ID found in URL.");
      return;
    }

    const fetchSessionDetails = async () => {
      localStorage.removeItem('cart_length')
      try {
        setshowloader(true)
        if (itype == "platform") {
          const response = await axios.post('payments/get_checkout_session', { session_id: sessionId }, { withCredentials: true });
          if (response.status === "get_checkout_session") {
            localStorage.setItem('user_', response.username);
            localStorage.setItem('userole_', response.role);
            localStorage.setItem('cstpack', JSON.stringify(response.cstpack));
            localStorage.setItem('userdata', JSON.stringify(response.user));
            localStorage.setItem('cart_length',response.cart_count);
            const timer = setTimeout(() => {
              // navigate('/');
              window.location.href = '/';
            }, 4000); // 4 seconds delay
            setAlertMsgg({ ...alertMsgg, open: true, content: "Subscription activated!", type: "success" })
            setshowloader(false);
            return () => clearTimeout(timer);
          } else { setError("Failed to retrieve session details."); setshowloader(false); }
        } else {
          const response = await axios.post('payments/get_expert_session', { session_id: sessionId ,cartsidebook:"cartsi_debook"}, { withCredentials: true });
          if (response.status === "verified") {
            // const timer = setTimeout(() => { navigate('/'); }, 5000); // 5 seconds delay
            // return () => clearTimeout(timer);
            console.log('cart_count dekhna h ',response.cart_count)
            localStorage.setItem('cart_length',response.cart_count)
            setTimeout(() => { window.location.href = '/cbookings'; }, 1500);
            setAlertMsgg({ ...alertMsgg, open: true, content: "Expert booked!", type: "success" })
            setshowloader(false);
          } else {
            setError("Failed to retrieve session details."); setshowloader(false);
          }
        }
      } catch (error: any) {
        if (error.response) {
          if ([401, 422].includes(error.response.status)) { setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" }); }
          else if (error.response.status === 403) {
            setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
            setTimeout(() => { window.location.href = "/logout" }, 2000)
          } else { setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" }); }
        } else { setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" }); }
        setshowloader(false);
      }
    };

    fetchSessionDetails();
  }, [sessionId]);

  //meta title
  document.title = "Confirm Mail | BizServe";

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <div className="loaderContainer" hidden={!showloader}>
          <div className="spinner">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <Container className="mt-5 pt-sm-5">
          <Row>
            <Col lg={12}>
              <div className="text-center mb-5 text-muted">
                <Link to="/dashboard" className="d-block auth-logo">
                  <img
                    src={logodark}
                    alt=""
                    height="50"
                    className="auth-logo-dark mx-auto"
                  />
                  <img
                    src={logolight}
                    alt=""
                    height="50"
                    className="auth-logo-light mx-auto"
                  />
                </Link>
                {/* <p className="mt-3">React Admin & Dashboard Template</p> */}
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card>
                <CardBody>
                  <div className="p-2">
                    {(error) ? (
                      <div className="text-center">
                        <div className="avatar-md mx-auto">
                          <div className="avatar-title rounded-circle bg-light">
                            <i className="bx bx-mail-send h1 mb-0 text-primary"></i>
                          </div>
                        </div>
                        <div className="p-2 mt-4">
                          <div className='cardThankMsg' style={{ textAlign: 'center', }}>
                            <h4>{error}</h4>
                            {/* <p>You can now sign in, explore the portal, and start connecting with experts. Find the right expert for your needs and make the most of your subscription!</p> */}
                          </div>
                          <div className="mt-4">
                            <button style={{ backgroundColor: '#ccc', color: '#333', border: 'none', padding: '10px 20px', borderRadius: '5px', cursor: 'pointer', marginTop: '20px' }} onClick={() => (window.location.href = '/')} >Back to Home</button>
                            {/* <Link to="/dashboard" className="btn btn-primary"> Back to Home </Link> */}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="text-center">
                        <div className="avatar-md mx-auto">
                          <div className="avatar-title rounded-circle bg-light">
                            <i className="bx bx-mail-send h1 mb-0 text-primary"></i>
                          </div>
                        </div>
                        <div className="p-2 mt-4">
                          <h1>{headTitle}</h1>
                          <p>{subTitle}</p>
                          {(itype == 'platform') ?
                            (<div className="mt-4">
                              <button style={{ backgroundColor: '#ccc', color: '#333', border: 'none', padding: '10px 20px', borderRadius: '5px', cursor: 'pointer', marginTop: '20px' }} onClick={() => (window.location.href = '/')} >Back to Home</button>
                            </div>) :
                            (<div className="mt-4">
                              <button style={{ backgroundColor: '#ccc', color: '#333', border: 'none', padding: '10px 20px', borderRadius: '5px', cursor: 'pointer', marginTop: '20px' }} onClick={() => (window.location.href = '/cbookings')} >See bookings</button>
                            </div>)
                          }
                        </div>
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  © {new Date().getFullYear()} BizServe. Crafted with{" "}
                  <i className="mdi mdi-heart text-danger"></i> by BizServe LLC
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export const PackagePaymentSuccess = () => {


  const [alertMsgg, setAlertMsgg] = useState<any>({ open: false, type: "success", content: 'Messages here.', time: '2500' });
  const handleAlertMsggClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") { return; }
    setAlertMsgg({ ...alertMsgg, open: false })
  };
  const [showloader, setshowloader] = useState(true);  // State for tracking submission
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id")?.split('?type=')[0];
  const itype = searchParams.get("session_id")?.split('?type=')[1];
  const [error, setError] = useState('');

  const [headTitle, setHeadTitle] = useState(() => {
    const type = searchParams.get("session_id")?.split('?type=')[1];
    return type === 'company_formation' ? 'Your company formation order is successful!' : 'Your order is successful.';
  });
  const [subTitle, setSubTitle] = useState(() => {
    const type = searchParams.get("session_id")?.split('?type=')[1];
    return type === 'company_formation' 
      ? 'Your order has been confirmed and is being processed. You can view your order details in the orders page.' 
      : 'You can now enjoy BizServe services. We have sent you an email with your order details.';
  });

  useEffect(() => {
    if (!sessionId) {
      // setAlertMsgg({ ...alertMsgg, open: true, content:"Invalid URL!", type:"error" })
      setError("❌ No session ID found in URL.");
      return;
    }

    const fetchSessionDetails = async () => {
      try {
        setshowloader(true)
        
        // Determine which endpoint to call based on order type
        let endpoint = 'payments/get_package_checkout_session';
        if (itype === 'company_formation') {
          endpoint = 'companyFormation/getCheckoutSession';
        }
        
        const response = await axios.post(endpoint, { session_id: sessionId }, { withCredentials: true });

        if (response.status === "get_checkout_session" || response.status === "already_executed_checkout_session") {
          localStorage.setItem('user_', response.username);
          localStorage.setItem('userole_', response.role);
          localStorage.setItem('userdata', JSON.stringify(response.user));
          
          // Update success message based on order type
          const successMessage = itype === 'company_formation' 
            ? "Company formation order confirmed!" 
            : "Subscription activated!";
          
          const timer = setTimeout(() => {
            window.location.href = '/corders';
          }, 4000); // 4 seconds delay
          setAlertMsgg({ ...alertMsgg, open: true, content: successMessage, type: "success" })
          setshowloader(false);
          return () => clearTimeout(timer);
        } else { setError("Failed to retrieve session details."); setshowloader(false); }
      } catch (error: any) {
        if (error.response) {
          if ([401, 422].includes(error.response.status)) { setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data.error, type: "error" }); }
          else if (error.response.status === 403) {
            setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
            setTimeout(() => { window.location.href = "/logout" }, 2000)
          } else { setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" }); }
        } else { setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" }); }
        setshowloader(false);
      }
    };

    fetchSessionDetails();
  }, [sessionId]);

  //meta title
  document.title = "Confirm Mail | BizServe";

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <div className="loaderContainer" hidden={!showloader}>
          <div className="spinner">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <Container className="mt-5 pt-sm-5">
          <Row>
            <Col lg={12}>
              <div className="text-center mb-5 text-muted">
                <Link to="/dashboard" className="d-block auth-logo">
                  <img
                    src={logodark}
                    alt=""
                    height="50"
                    className="auth-logo-dark mx-auto"
                  />
                  <img
                    src={logolight}
                    alt=""
                    height="50"
                    className="auth-logo-light mx-auto"
                  />
                </Link>
                {/* <p className="mt-3">React Admin & Dashboard Template</p> */}
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card>
                <CardBody>
                  <div className="p-2">
                    {(error) ? (
                      <div className="text-center">
                        <div className="avatar-md mx-auto">
                          <div className="avatar-title rounded-circle bg-light">
                            <i className="bx bx-mail-send h1 mb-0 text-primary"></i>
                          </div>
                        </div>
                        <div className="p-2 mt-4">
                          <div className='cardThankMsg' style={{ textAlign: 'center', }}>
                            <h4>{error}</h4>
                            {/* <p>You can now sign in, explore the portal, and start connecting with experts. Find the right expert for your needs and make the most of your subscription!</p> */}
                          </div>
                          <div className="mt-4">
                            <button style={{ backgroundColor: '#ccc', color: '#333', border: 'none', padding: '10px 20px', borderRadius: '5px', cursor: 'pointer', marginTop: '20px' }} onClick={() => (window.location.href = '/')} >Back to Home</button>
                            {/* <Link to="/dashboard" className="btn btn-primary"> Back to Home </Link> */}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div className="text-center">
                        <div className="avatar-md mx-auto">
                          <div className="avatar-title rounded-circle bg-light">
                            <i className="bx bx-mail-send h1 mb-0 text-primary"></i>
                          </div>
                        </div>
                        <div className="p-2 mt-4">
                          <h1>{headTitle}</h1>
                          <p>{subTitle}</p>
                          <div className="mt-4">
                              <button style={{ backgroundColor: '#ccc', color: '#333', border: 'none', padding: '10px 20px', borderRadius: '5px', cursor: 'pointer', marginTop: '20px' }} onClick={() => (window.location.href = '/')} >Back to Home</button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  © {new Date().getFullYear()} BizServe. Crafted with{" "}
                  <i className="mdi mdi-heart text-danger"></i> by BizServe LLC
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default PaymentSuccess
